import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import PAYMENTS_API_URL from 'utils/PaymentsApiUrl'
import { last } from 'lodash'

export const getClientToken =
  (argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.CLIENT_TOKEN_READ_REQUEST,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${PAYMENTS_API_URL}/client_token`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then((payload) =>
            payload && payload.notOk
              ? dispatch({
                type: ActionType.PAYMENTS_MANAGER.CLIENT_TOKEN_READ_FAILURE,
                payload,
                notOk: true,
                ...argObject,
              })
              : dispatch({
                  type: ActionType.PAYMENTS_MANAGER.CLIENT_TOKEN_READ_SUCCESS,
                  payload,
                  ...argObject,
                }),
          )
          .catch((error) =>
            dispatch({
              type: ActionType.PAYMENTS_MANAGER.CLIENT_TOKEN_READ_FAILURE,
              payload: error,
              ...argObject,
            }),
          )
      })
      .catch((err) => {
        console.log(err)
      })
  }
export const addPaymentMethod =
  (payment_nonce, copySource, argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.ADD_PAYMENT_METHOD_REQUEST,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${PAYMENTS_API_URL}/move`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'PUT', // *GET, POST, PUT, DELETE, etc.
          body: JSON.stringify({
            payment_nonce,
          }),
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then((payload) =>
            payload && payload.notOk
              ? dispatch({
                  type: ActionType.PAYMENTS_MANAGER.ADD_PAYMENT_METHOD_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
              : dispatch({
                  type: ActionType.PAYMENTS_MANAGER.ADD_PAYMENT_METHOD_SUCCESS,
                  payload,
                  ...argObject,
                }),
          )
          .catch((error) =>
            dispatch({
              type: ActionType.PAYMENTS_MANAGER.ADD_PAYMENT_METHOD_FAILURE,
              payload: error,
              ...argObject,
            }),
          )
      })
      .catch((err) => {
        console.log(err)
      })
  }
export const getPlans =
  (argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.PLANS_READ_REQUEST,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${PAYMENTS_API_URL}/plan`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then((payload) =>
            payload && payload.notOk
              ? dispatch({
                  type: ActionType.PAYMENTS_MANAGER.PLANS_READ_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
              : dispatch({
                  type: ActionType.PAYMENTS_MANAGER.PLANS_READ_SUCCESS,
                  payload,
                  ...argObject,
                }),
          )
          .catch((error) =>
            dispatch({
              type: ActionType.PAYMENTS_MANAGER.PLANS_READ_FAILURE,
              payload: error,
              ...argObject,
            }),
          )
      })
      .catch((err) => {
        console.log(err)
      })
  }

export const createSubscription =
  (planId, payment_nonce, argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.CREATE_SUBSCRIPTION_REQUEST,
      ...argObject,
    })

    const customer = getState().paymentsManager.customer
    const addresses = customer && customer.addresses
    const address  = last(addresses)

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${PAYMENTS_API_URL}/subscription`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          body: JSON.stringify({
            planId,
            payment_nonce,
            address,
          }),
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then((payload) =>
            payload && payload.notOk
              ? dispatch({
                  type: ActionType.PAYMENTS_MANAGER.CREATE_SUBSCRIPTION_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
              : dispatch({
                  type: ActionType.PAYMENTS_MANAGER.CREATE_SUBSCRIPTION_SUCCESS,
                  payload,
                  ...argObject,
                }),
          )
          .catch((error) =>
            dispatch({
              type: ActionType.PAYMENTS_MANAGER.CREATE_SUBSCRIPTION_FAILURE,
              payload: error,
              ...argObject,
            }),
          )
      })
      .catch((err) => {
        console.log(err)
      })
  }

export const createAddress =
  (address, argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.CREATE_ADDRESS_REQUEST,
      address,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${PAYMENTS_API_URL}/customeraddress`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          body: JSON.stringify(address),
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then((payload) =>
            payload && payload.notOk
              ? dispatch({
                  type: ActionType.PAYMENTS_MANAGER.CREATE_ADDRESS_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
              : dispatch({
                  type: ActionType.PAYMENTS_MANAGER.CREATE_ADDRESS_SUCCESS,
                  payload,
                  ...argObject,
                }),
          )
          .catch((error) =>
            dispatch({
              type: ActionType.PAYMENTS_MANAGER.CREATE_ADDRESS_FAILURE,
              payload: error,
              ...argObject,
            }),
          )
      })
      .catch((err) => {
        console.log(err)
      })
  }

export const updateAddress =
  (address, id, argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.UPDATE_ADDRESS_REQUEST,
      address,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${PAYMENTS_API_URL}/customeraddress`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'PUT', // *GET, POST, PUT, DELETE, etc.
          body: JSON.stringify({ address, id }),
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then((payload) =>
            payload && payload.notOk
              ? dispatch({
                  type: ActionType.PAYMENTS_MANAGER.UPDATE_ADDRESS_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
              : dispatch({
                  type: ActionType.PAYMENTS_MANAGER.UPDATE_ADDRESS_SUCCESS,
                  payload,
                  id,
                  ...argObject,
                }),
          )
          .catch((error) =>
            dispatch({
              type: ActionType.PAYMENTS_MANAGER.UPDATE_ADDRESS_FAILURE,
              payload: error,
              ...argObject,
            }),
          )
      })
      .catch((err) => {
        console.log(err)
      })
  }

export const updateSubscription =
  (planId, payment_nonce, id, argObject = {}) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.PAYMENTS_MANAGER.UPDATE_SUBSCRIPTION_REQUEST,
        ...argObject,
      })

      return Auth.currentSession()
        .then((session) => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${PAYMENTS_API_URL}/subscription`, {
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'PUT', // *GET, POST, PUT, DELETE, etc.
            body: JSON.stringify({
              planId,
              payment_nonce,
              id,
            }),
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then((res) =>
              res.json().then((data) => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then((payload) => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.PAYMENTS_MANAGER.UPDATE_SUBSCRIPTION_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
                reject(payload)
                return
              }
              dispatch({
                type: ActionType.PAYMENTS_MANAGER.UPDATE_SUBSCRIPTION_SUCCESS,
                payload,
                ...argObject,
              })
              resolve(payload)
            })
            .catch((error) => {
              dispatch({
                type: ActionType.PAYMENTS_MANAGER.UPDATE_SUBSCRIPTION_FAILURE,
                payload: error,
                ...argObject,
              })
              reject(error)
            })
        })
        .catch((err) => {
          console.log(err)
        })
    })

export const getSubscription =
  (argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.SUBSCRIPTION_READ_REQUEST,
      ...argObject,
    })

    return Auth.currentSession()
      .then((session) => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${PAYMENTS_API_URL}/subscription`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) =>
            res.json().then((data) => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then((payload) =>
            payload && payload.notOk
              ? dispatch({
                  type: ActionType.PAYMENTS_MANAGER.SUBSCRIPTION_READ_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
              : dispatch({
                  type: ActionType.PAYMENTS_MANAGER.SUBSCRIPTION_READ_SUCCESS,
                  payload,
                  ...argObject,
                }),
          )
          .catch((error) =>
            dispatch({
              type: ActionType.PAYMENTS_MANAGER.SUBSCRIPTION_READ_FAILURE,
              payload: error,
              ...argObject,
            }),
          )
      })
      .catch((err) => {
        console.log(err)
      })
  }
export const getCustomer =
  (argObject = {}) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_REQUEST,
        ...argObject,
      })

      return Auth.currentSession()
        .then((session) => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${PAYMENTS_API_URL}/braintreecustomer`, {
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then((res) =>
              res.json().then((data) => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then((payload) => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_FAILURE,
                  payload,
                  notOk: true,
                  ...argObject,
                })
                reject(payload)
              } else {
                dispatch({
                  type: ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_SUCCESS,
                  payload,
                  ...argObject,
                })
                resolve(payload)
              }
            })
            .catch((error) => {
              dispatch({
                type: ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_FAILURE,
                payload: error,
                ...argObject,
              })
              reject(error)
            })
        })
        .catch((error) => {
          dispatch({
            type: ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_FAILURE,
            payload: error,
            ...argObject,
          })
          reject(error)
        })
    })

export const openPaymentsModal =
  (show, argObject = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: ActionType.PAYMENTS_MANAGER.OPEN_PAYMENTS_MODAL,
      show,
      ...argObject,
    })
  }
